<template>
  <div class="tw:flex tw:items-start tw:gap-4" :class="{ 'tw:opacity-60': tour.archived_at }">
    <a :href="tour.links.show" :target="openInNewWindow ? '_blank' : undefined" class="tw:hidden tw:md:block tw:shrink-0">
      <Avatar :size="50" :username="tour.name" :imgSrc="tour.logo_url" />
    </a>
    <div>
      <div class="tw:flex tw:items-center tw:gap-2">
        <a :href="tour.links.show" :target="openInNewWindow ? '_blank' : undefined">
          <strong>{{ tour.name }}</strong>
        </a>
        <template v-if="tour.archived_at">
          <LockIcon class="tw:size-3.5" />
        </template>
      </div>
      <div class="tw:text-sm tw:text-zinc-500">
        {{ tour.organization.name }}
      </div>
      <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-x-3 tw:gap-y-1 tw:mt-1">
        <span v-if="tour.country_name" class="tw:inline-flex tw:items-center tw:gap-1 tw:text-xs tw:text-zinc-500">
          <MapPinIcon class="tw:size-3" />
          {{ tour.country_name }}
        </span>
        <span v-if="tour.start_at && tour.end_at" class="tw:inline-flex tw:items-center tw:gap-1 tw:text-xs tw:text-zinc-500">
          <CalendarIcon class="tw:size-3" />
          {{ dayjs(tour.start_at).format('ll') }}
          <ChevronRightIcon class="tw:size-3" />
          {{ dayjs(tour.end_at).format('ll') }}
        </span>
      </div>
      <div v-if="activeFeatures.length > 0 || hasPendingValidation" class="tw:flex tw:flex-wrap tw:items-center tw:gap-1 tw:mt-2">
        <Tooltip v-if="hasPendingValidation" :title="$t('Your participation to this event is not yet confirmed.')">
          <span class="tw:inline-flex tw:items-center tw:gap-1 tw:px-2 tw:py-0.5 tw:rounded-full tw:bg-amber-100 tw:text-amber-800 tw:text-xs tw:cursor-help">
            <CircleAlertIcon class="tw:size-3" />
            {{ $t('Action required') }}
          </span>
        </Tooltip>
        <span
          v-for="[key, icon] in activeFeatures"
          :key="key"
          class="tw:inline-flex tw:items-center tw:gap-1 tw:px-2 tw:py-0.5 tw:rounded-full tw:bg-blue-100 tw:text-blue-800 tw:text-xs"
        >
          <component :is="icon" class="tw:size-3" />
          {{ $t(key) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Avatar from '@/components/ui/Avatar.vue'
import Tooltip from '@/components/ui/Tooltip.vue'
import { CalendarCheckIcon, ShoppingCartIcon, CreditCardIcon, ChevronRightIcon, LockIcon, MapPinIcon, CalendarIcon, CircleAlertIcon } from '@lucide/vue'
import dayjs from 'dayjs'

const props = defineProps({
  tour: {
    type: Object,
    required: true,
  },
  openInNewWindow: {
    type: Boolean,
    default: false,
  },
})

const featureIcons = {
  booking: CalendarCheckIcon,
  activity: ShoppingCartIcon,
  payment: CreditCardIcon,
}

const activeFeatures = computed(() => {
  if (!props.tour.features) return []
  return Object.entries(featureIcons).filter(([key]) => props.tour.features[key])
})

const hasPendingValidation = computed(() => (props.tour.pending_exponents_for_user?.length ?? 0) > 0)
</script>
